import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton, Box, TextField, Divider, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useContext } from 'react';
import { User } from '../../types/Types';
import { ThemeContext } from '../../theme/AppTheme'; // #POW-29
import { useTranslation } from "react-i18next"; // #POW-29
import useCustomFetch from '../../hooks/useCustomFetch'; // #POW-35
import Config from '../../Config'; // #POW-35
import AuthContext from '../../context/AuthContext'; // #POW-35

interface Preferences {
    locale: string;
} // #POW-35


// #POW-24
export default function DialogUserProfile(
    { open, onClose, user }: { open: boolean; onClose: () => void; user: User  }
){
    const themeContext = useContext(ThemeContext); // #POW-29
    const { localeValue, setLocalizations } = themeContext; // #POW-29

    const { i18n, t } = useTranslation(); // #POW-29
    const customFetch = useCustomFetch() // #POW-35
    const auth = useContext(AuthContext) // #POW-35
    


    // #POW-29
    const handleChangeLanguage = (event: SelectChangeEvent) => {
        const selectedLocale = event.target.value;
        setLocalizations(selectedLocale);
        auth.setLocale(selectedLocale) // #POW-35 update session data
        savePreferences({
            locale: selectedLocale
        }) // #POW-35 save to db
      };

    /**
     * #POW-35
     * Save user preferences
     * @param preferences 
     */
    const savePreferences = async (preferences: Preferences) => {
        const url = `${Config.serverUrl}/api/user/preferences`;
        const response = await customFetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                locale: preferences.locale
              })
          });
      
          if (response.ok) { // some feedback?
          }
    }

      
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
            <DialogTitle fontWeight={'bold'}>{t('profile.title')}</DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                }}
                >
            <CloseIcon />
            </IconButton>
            <DialogContent dividers>
            <Box component="form" noValidate autoComplete="off">
                <TextField
                    margin="dense"
                    label={t('profile.fullName')}
                    disabled
                    type="text"
                    fullWidth
                    value={user.fullName || ''}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField
                    margin="dense"
                    disabled
                    label={t('profile.email')}
                    type="email"
                    fullWidth
                    value={user.email || ''}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField
                    margin="dense"
                    label={t('profile.role')}
                    type="text"
                    disabled
                    fullWidth
                    value={user.entitlement || ''}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField
                    margin="dense"
                    label={t('profile.jobTitle')}
                    disabled
                    type="text"
                    fullWidth
                    value={user.jobTitle || ''}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <TextField
                    margin="dense"
                    label={t('profile.officeLocation')}
                    disabled
                    type="text"
                    fullWidth
                    value={user.officeLocation || ''}
                    InputProps={{
                        readOnly: true,
                    }}
                />
                <Divider sx={{marginTop:"8px"}}/>
                <Box mt={2}> {/* #POW-29 */}
                    <FormControl fullWidth>
                        <InputLabel id="language-select-label">{t('profile.language')}</InputLabel>
                        <Select
                            label="language-select-label"
                            value={localeValue}
                            onChange={handleChangeLanguage}
                        >
                        <MenuItem value="en">{t("locales.en")}</MenuItem>
                        <MenuItem value="it">{t("locales.it")}</MenuItem>
                        <MenuItem value="pt">{t("locales.pt")}</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>
            </DialogContent>
            <DialogActions>
            <Button type="submit" color="primary" variant="contained" onClick={onClose}>{t('profile.close')}</Button>
            </DialogActions>
        </Dialog>
    )
}